import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../../common/icon/icon.module';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
  imports: [IconModule, CommonModule],
})
export class CheckboxModule {}

export { CheckboxComponent } from './checkbox.component';
